import { defineComponent as _defineComponent } from 'vue'
import { computed, provide, ref } from 'vue'

import LButton from '@/components/core/Button.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import { showMenuSymbol } from '@/components/notification/utils'
import NotificationMenuItem from '@/components/notification/NotificationMenuItem.vue'
import {
  useMarkAllNotificationsAsRead,
  useNotificationList,
} from '@/composables/notification'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationMenu',
  setup(__props) {

const { data, refetch } = useNotificationList()
const { mutate: markAllNotificationsAsRead } = useMarkAllNotificationsAsRead()

const showMenu = ref(false)
provide(showMenuSymbol, showMenu)

const visibleNotifications = computed(() => {
  return data.value?.notifications.filter((n) => !n.hidden) ?? []
})

const newNotificationCount = computed(() => {
  if (!data.value) {
    return 0
  }
  return data.value?.notifications.reduce((count, notification) => {
    return !notification.read && !notification.hidden ? count + 1 : count
  }, 0)
})

return { __sfc: true,data, refetch, markAllNotificationsAsRead, showMenu, visibleNotifications, newNotificationCount, LButton, DropdownMenu, NotificationMenuItem }
}

})